module.exports = __webpack_public_path__ + "img/metlife_eng_logo_rgb.87884b18.png";